/* 🤖 this file was generated by script */
export const wiconCardSent = {
  name: 'card_sent',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.5" d="M16.68 10V6.55c0-.7-.57-1.27-1.28-1.27H4.46c-.7 0-1.27.57-1.27 1.27v7.19c0 .7.57 1.27 1.27 1.27H10"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" d="M3.2 7.51h13.48m0 1.84H3.19m1.46 3.46h2.4m-2.4-1.31h2.4m8.81.33l1.64 1.7m-1.64 1.7l1.64-1.7m-7.96 0h7.96"/></svg>`,
};
